export default __webpack_public_path__ + "images/95aa30d90754015514f5726170838acd-fighterHelicopter2.png";